/* eslint-disable */
import moment from 'moment';

const TileLayers = (function() {
  const layers = {
    esri: {
      name: 'Esri',
      attribution:
        'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      maxZoom: 19,
    },
    worldstreetmap: {
      name: "World Street Map",
      attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', 
      maxZoom: 19,
    },
    worldtopomap: {
      name: "World Topo Street Map",
      attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community',
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
      maxZoom: 19,
    },
    googleStreets: {
      name: "Google Streets",
      attribution: "Maps Data Google, ©" + moment().format('YYYY'),
      url: "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
      subdomains: ['mt0','mt1','mt2','mt3'],
      maxZoom: 20,
    },
    googleHybrid: {
      name: "Google Hybrid",
      attribution: "Maps Data Google, ©" + moment().format('YYYY'),
      url: "https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
      subdomains: ['mt0','mt1','mt2','mt3'],
      maxZoom: 20,
    },
    googleSat: {
      name: "Google Satellite",
      attribution: "Maps Data Google, ©" + moment().format('YYYY'),
      url: "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
      subdomains: ['mt0','mt1','mt2','mt3'],
      maxZoom: 20,
    },
    /*
    mapboxsat: {
      name: 'MapBox Satellite',
      attribution: 'Mapbox',
      style: 'mapbox://styles/mapbox/satellite-v9',
      mapbox: true,
      maxZoom: 20,
    },
    mapboxstreet: {
      name: 'MapBox Streets',
      attribution: 'Mapbox',
      style: 'mapbox://styles/mapbox/streets-v9',
      mapbox: true,
      maxZoom: 20,
    },
    mapboxoutdoors: {
      name: 'MapBox Outdoors',
      attribution: 'Mapbox',
      style: 'mapbox://styles/mapbox/outdoors-v10',
      mapbox: true,
      maxZoom: 20,
    },
    */
    soilsurvey: {
      name: 'Esri Soil Type',
      attribution: 'Powered by Esri',
      url:
        'https://services.arcgisonline.com/arcgis/rest/services/Specialty/Soil_Survey_Map/MapServer/tile/{z}/{y}/{x}',
      maxZoom: 16,
    },
    openstreetmap: {
      name: 'OpenStreetMap',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
      maxZoom: 20,
    },
    globalsoils6texture: {
      name: 'Global Soils 6" Texture',
      attribution: 'Teralytic',
      url:
        'https://api.mapbox.com/styles/v1/jayventura/cjvfocblg184e1fo6czwfhk64/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiamF5dmVudHVyYSIsImEiOiJjajVsZHNqZTQydHRjMzNuejY0YTZqYnI5In0.akDaOWXKYKN8kvDiAZNbwQ',
      maxZoom: 22,
      grades: [
        { color: '#a93939', value: 'Clay' },
        { color: '#c990c9', value: 'Silty Clay' },
        { color: '#ffc867', value: 'Sandy Clay' },
        { color: '#ba7c7c', value: 'Clay Loam' },
        { color: '#856685', value: 'Silty Clay Loam' },
        { color: '#ac8e5b', value: 'Sandy Clay Loam' },
        { color: '#595050', value: 'Loam' },
        { color: '#4c4c96', value: 'Silty Loam' },
        { color: '#cdcd5c', value: 'Sandy Loam' },
        { color: '#8d93fc', value: 'Silt' },
        { color: '#a6a65b', value: 'Loamy Sand' },
        { color: '#ffffcc', value: 'Sand' },
      ],
    },
    globalsoils6clay: {
      name: 'Global Soils 6" Clay',
      attribution: 'Teralytic',
      url:
        'https://api.mapbox.com/styles/v1/jayventura/cjv702c4p1ixw1fr7l4ol3u4j/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiamF5dmVudHVyYSIsImEiOiJjajVsZHNqZTQydHRjMzNuejY0YTZqYnI5In0.akDaOWXKYKN8kvDiAZNbwQ',
        maxZoom: 22,
        grades: [
          { color: '#ffffcc', value: '0%' },
          { color: '#a1dab4', value: '18%' },
          { color: '#41b6c4', value: '36%' },
          { color: '#2c7fb8', value: '54%' },
          { color: '#253494', value: '72%' },
        ],
    },
    globalsoils18claygl: {
            name: 'Global Soils 18" Clay',
            attribution: 'Teralytic',
            maxZoom: 22,
            url:
            'https://api.mapbox.com/styles/v1/jayventura/cjvoaub2207dq1co3x1el5n2r/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiamF5dmVudHVyYSIsImEiOiJjajVsZHNqZTQydHRjMzNuejY0YTZqYnI5In0.akDaOWXKYKN8kvDiAZNbwQ',
                style: 'mapbox://styles/jayventura/cjvoaub2207dq1co3x1el5n2r',
            grades: [
              { color: '#ffffcc', value: '0%' },
              { color: '#a1dab4', value: '18%' },
              { color: '#41b6c4', value: '36%' },
              { color: '#2c7fb8', value: '54%' },
              { color: '#253494', value: '72%' },
            ],
          },
    globalsoils36claygl: {
      name: 'Global Soils 36" Clay',
      attribution: 'Teralytic',
      url:
        'https://api.mapbox.com/styles/v1/jayventura/cjvoaxmge07hq1cqkmfv35k84/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiamF5dmVudHVyYSIsImEiOiJjajVsZHNqZTQydHRjMzNuejY0YTZqYnI5In0.akDaOWXKYKN8kvDiAZNbwQ',
        maxZoom: 22,
        grades: [
        { color: '#ffffcc', value: '0%' },
        { color: '#a1dab4', value: '18%' },
        { color: '#41b6c4', value: '36%' },
        { color: '#2c7fb8', value: '54%' },
        { color: '#253494', value: '72%' },
      ],
    },
    globalsoils6siltgl: {
      name: 'Global Soils 6" Silt',
      attribution: 'Teralytic',
      maxZoom: 22,
      url:
        'https://api.mapbox.com/styles/v1/jayventura/cjvoaoxjh079i1do5euhi5hev/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiamF5dmVudHVyYSIsImEiOiJjajVsZHNqZTQydHRjMzNuejY0YTZqYnI5In0.akDaOWXKYKN8kvDiAZNbwQ',
      style: 'mapbox://styles/jayventura/cjvoaoxjh079i1do5euhi5hev',
      grades: [
        { color: '#ffffcc', value: '1%' },
        { color: '#a1dab4', value: '19.75%' },
        { color: '#41b6c4', value: '38.5%' },
        { color: '#2c7fb8', value: '57.25%' },
        { color: '#253494', value: '76%' },
      ],
    },
    globalsoils18siltgl: {
      name: 'Global Soils 18" Silt',
      attribution: 'Teralytic',
      maxZoom: 22,
      url:
        'https://api.mapbox.com/styles/v1/jayventura/cjvob0b3107m21crqu0xkzgwu/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiamF5dmVudHVyYSIsImEiOiJjajVsZHNqZTQydHRjMzNuejY0YTZqYnI5In0.akDaOWXKYKN8kvDiAZNbwQ',
      style: 'mapbox://styles/jayventura/cjvob0b3107m21crqu0xkzgwu',
      grades: [
        { color: '#ffffcc', value: '0%' },
        { color: '#a1dab4', value: '18%' },
        { color: '#41b6c4', value: '36%' },
        { color: '#2c7fb8', value: '54%' },
        { color: '#253494', value: '72%' },
      ],
    },
    globalsoils36siltgl: {
      name: 'Global Soils 36" Silt',
      maxZoom: 22,
      attribution: 'Teralytic',
      url:
        'https://api.mapbox.com/styles/v1/jayventura/cjvob30pu07my1dogdb9yni77/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiamF5dmVudHVyYSIsImEiOiJjajVsZHNqZTQydHRjMzNuejY0YTZqYnI5In0.akDaOWXKYKN8kvDiAZNbwQ',
      style: 'mapbox://styles/jayventura/cjvob30pu07my1dogdb9yni77',
      grades: [
        { color: '#ffffcc', value: '0%' },
        { color: '#a1dab4', value: '17.75%' },
        { color: '#41b6c4', value: '35.5%' },
        { color: '#2c7fb8', value: '53.25%' },
        { color: '#253494', value: '71%' },
      ],
    },
    globalsoils6sandgl: {
      name: 'Global Soils 6" Sand',
      attribution: 'Teralytic',
      maxZoom: 22,
      url:
        'https://api.mapbox.com/styles/v1/jayventura/cjvoad9ns07071cqjgn2yi8ew/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiamF5dmVudHVyYSIsImEiOiJjajVsZHNqZTQydHRjMzNuejY0YTZqYnI5In0.akDaOWXKYKN8kvDiAZNbwQ',
      style: 'mapbox://styles/jayventura/cjvoad9ns07071cqjgn2yi8ew',
      grades: [
        { color: '#ffffcc', value: '0%' },
        { color: '#a1dab4', value: '24.25%' },
        { color: '#41b6c4', value: '48.5%' },
        { color: '#2c7fb8', value: '72.75%' },
        { color: '#253494', value: '97%' },
      ],
    },
    globalsoils18sandgl: {
      name: 'Global Soils 18" Sand',
      attribution: 'Teralytic',
      url:
        'https://api.mapbox.com/styles/v1/jayventura/cjvobclki07ti1cr1nz6xi986/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiamF5dmVudHVyYSIsImEiOiJjajVsZHNqZTQydHRjMzNuejY0YTZqYnI5In0.akDaOWXKYKN8kvDiAZNbwQ',
      style: 'mapbox://styles/jayventura/cjvobclki07ti1cr1nz6xi986',
      maxZoom: 22,
      grades: [
        { color: '#ffffcc', value: '0%' },
        { color: '#a1dab4', value: '24.5%' },
        { color: '#41b6c4', value: '49%' },
        { color: '#2c7fb8', value: '73.5%' },
        { color: '#253494', value: '98%' },
      ],
    },
    globalsoils36sandgl: {
      name: 'Global Soils 36" Sand',
      attribution: 'Teralytic',
      url:
        'https://api.mapbox.com/styles/v1/jayventura/cjvobfjpp080h1crqzewx1egh/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiamF5dmVudHVyYSIsImEiOiJjajVsZHNqZTQydHRjMzNuejY0YTZqYnI5In0.akDaOWXKYKN8kvDiAZNbwQ',
      style: 'mapbox://styles/jayventura/cjvobfjpp080h1crqzewx1egh',
      maxZoom: 22,
      grades: [
        { color: '#ffffcc', value: '0%' },
        { color: '#a1dab4', value: '24.75%' },
        { color: '#41b6c4', value: '49.5%' },
        { color: '#2c7fb8', value: '74.25%' },
        { color: '#253494', value: '99%' },
      ],
    },
  };

  return {
    layers,
  };
})();
/* eslint-enable */
export default TileLayers;
